// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2iSke","box":"WorkspacesBox_box__uriXP","node":"WorkspacesBox_node__2MuYL"};